import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Navbar = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { theme, toggleTheme, isDark } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Sun icon SVG (for switching to light mode)
  const SunIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5"></circle>
      <line x1="12" y1="1" x2="12" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="23"></line>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
      <line x1="1" y1="12" x2="3" y2="12"></line>
      <line x1="21" y1="12" x2="23" y2="12"></line>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
    </svg>
  );

  // Moon icon SVG (for switching to dark mode)
  const MoonIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
    </svg>
  );

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Mobile Theme Toggle - Left Side */}
        <button 
          className="theme-toggle mobile-theme-toggle" 
          onClick={toggleTheme}
          aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
          title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
          {isDark ? <SunIcon /> : <MoonIcon />}
        </button>

        <Link to="/" className="navbar-logo">
          <img src="/almed-logo.png" alt="ALMED Equipment" />
        </Link>

        <button className="navbar-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <NavLink to="/" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.home')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.about')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/products" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.products')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.services')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/gallery" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.gallery')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/blog" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.blog')}
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className="navbar-link" onClick={() => setIsMenuOpen(false)}>
              {t('nav.contact')}
            </NavLink>
          </li>
          {/* Mobile Language Selector */}
          <li className="mobile-language-item">
            <LanguageSelector />
          </li>
        </ul>

        <div className="navbar-actions">
          {/* Language Selector */}
          <LanguageSelector />
          
          <Link to="/contact" className="btn btn-primary">
            {t('nav.getQuote')}
          </Link>
          {/* Theme Toggle Button - Desktop */}
          <button 
            className="theme-toggle desktop-theme-toggle" 
            onClick={toggleTheme}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
